import React from "react";
import { IconType, IconBaseProps } from "react-icons";

interface IconWrapperProps extends IconBaseProps {
  icon: IconType;
}

export const IconWrapper: React.FC<IconWrapperProps> = ({ icon, ...props }) => {
  const element = icon(props);
  return element as React.ReactElement;
};
